import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import endPoint from "../../websitecomponents/redux/EndPoint/endpoint";

const MpProduct = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  const token = localStorage.getItem("ResellerTokenData");

  const getImageUrl = (path) => {
    if (!path) return "";
    return `https://www.bharatcod.com/${path.replace(/\\/g, "/")}`;
  };

  const fetchProducts = async () => {
    try {
      const res = await axios.get(endPoint.GetAllResellerProducts, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        setProducts(res.data.data);
      }
    } catch (err) {
      toast.error("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const createSlug = (text) => {
    return text
      ?.toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-");
  };

  const handleGenerateLink = (item) => {
    const link = `${window.location.origin}/product/reseller/${item._id}`;
    navigator.clipboard.writeText(link);
    toast.success("Link Copied!");
  };

  return (
    <div className="p-2 min-h-screen">
      {loading && <p className="text-center">Loading...</p>}

      {!loading && products.length === 0 && (
        <p className="text-center">No Products Found</p>
      )}

      {!loading && products.length > 0 && (
        <div className="bg-white rounded-xl shadow overflow-auto">
          <table className="min-w-full text-sm">
            {/* HEADER */}
            <thead className="bg-gray-200">
              <tr>
                <th className="p-3 border">Image</th>
                <th className="p-3 border">Title</th>
                <th className="p-3 border">Category</th>
                <th className="p-3 border">Base Price</th>
                <th className="p-3 border">Margin</th>
                <th className="p-3 border">Final Price</th>
                <th className="p-3 border">Profit</th>
                <th className="p-3 border">Description</th>
                <th className="p-3 border">Action</th>
              </tr>
            </thead>

            {/* BODY */}
            <tbody>
              {products.map((item) => (
                <tr key={item._id} className="border-t hover:bg-gray-50">
                  {/* IMAGE */}
                  <td className="p-2">
                    {item.image ? (
                      <img
                        src={getImageUrl(item.image)}
                        alt=""
                        className="w-14 h-14 object-cover rounded cursor-pointer"
                        onClick={() =>
                          setSelectedImage(getImageUrl(item.image))
                        }
                      />
                    ) : (
                      <div className="w-14 h-14 bg-gray-200 flex items-center justify-center text-xs">
                        No Image
                      </div>
                    )}
                  </td>

                  {/* TITLE */}
                  <td className="p-2 font-medium">{item.title}</td>

                  {/* CATEGORY */}
                  <td className="p-2">
                    {item.category} / {item.subcategory}
                  </td>

                  {/* BASE PRICE */}
                  <td className="p-2">₹{item.basePrice}</td>

                  {/* MARGIN */}
                  <td className="p-2">
                    {item.marginType === "percent"
                      ? `${item.marginValue}%`
                      : `₹${item.marginValue}`}
                  </td>

                  {/* FINAL PRICE */}
                  <td className="p-2 font-semibold text-green-600">
                    ₹{item.finalPrice}
                  </td>

                  {/* PROFIT */}
                  <td className="p-2 text-blue-600 font-medium">
                    ₹{item.resellerEarning}
                  </td>

                  {/* DESCRIPTION */}
                  <td className="p-2 max-w-xs truncate">{item.description}</td>

                  {/* ACTION */}
                  <td className="p-2">
                    <button
                      onClick={() => handleGenerateLink(item)}
                      className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded"
                    >
                      Copy Product Link
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* IMAGE MODAL */}
      <Modal show={!!selectedImage} onHide={() => setSelectedImage(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={selectedImage} alt="" className="w-full" />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MpProduct;
